const folderClasses = [
    'alert-primary',
    'alert-success',
    'alert-info',
    'alert-dark',
    'alert-warning',
    'alert-danger',
]

export default folderClasses